import Vue from 'vue';
import iView from 'iview'
import Clipboard from 'clipboard';


let aips='';
let token='';
let getParam=function getParam(){
  var search = {};
  try {
    location.search
      .substr(1)
      .split('&')
      .forEach(function(item) {
        var s = item.split('=');
        search[s[0]] = s[1];
      });
  } catch (e) {
    // 抛出异常
    throw new Error(JSON.stringify(search));
  }
  return search;
};
let ispc=function ispc(){
  return !/Android|webOS|iPhone|iPod|BlackBerry/i.test(navigator.userAgent)
}
if(location.href.indexOf(":80")!=-1){
  aips="/apis";
}
var global = {
  // 测试使用
  ispc:ispc(),
  getParam:getParam,// 获取url参数返回json
  transferDate(times){//时间戳转时间
    var date = new Date(times);
    var Y = date.getFullYear() + '-';
    var M = (date.getMonth()+1 < 10 ? '0'+(date.getMonth()+1) : date.getMonth()+1) + '-';
    var D = (date.getDate() < 10 ? '0'+date.getDate() : date.getDate()) + ' ';
    var h = (date.getHours() < 10 ? '0'+date.getHours() : date.getHours()) + ':';
    var m = (date.getMinutes() < 10 ? '0'+date.getMinutes() : date.getMinutes()) + ':';
    var s = date.getSeconds() < 10 ? '0'+date.getSeconds() : date.getSeconds();
    return Y+M+D+h+m+s;
  },
  transferYear(times){//时间戳转时间年月日
    var date = new Date(times);
    var Y = date.getFullYear() + '-';
    var M = (date.getMonth()+1 < 10 ? '0'+(date.getMonth()+1) : date.getMonth()+1) + '-';
    var D = (date.getDate() < 10 ? '0'+date.getDate() : date.getDate());
    return Y+M+D;
  },
  transferTime(times){//时间转时间戳
    return new Date(times).getTime();
  },
  copyArr(arr){//拷贝数组
    return Object.assign([], arr)
  },
  copyObj(obj){//拷贝对象
    return Object.assign({}, obj)
  },
  copy(mobile){
      var Url = mobile;
      var clipboard = new Clipboard('.tag-read', {
          text: function() {
              return Url;
          }
      });
      clipboard.on('success', e => {
        iView.Message.success('复制成功');
        // 释放内存
        clipboard.destroy()
      })
      clipboard.on('error', e => {
        // 不支持复制
        iView.Message.warning('该浏览器不支持自动复制');
        // 释放内存
        clipboard.destroy()
      })
  },
  sortByKey(array,key){  //(数组、排序的列)
      return array.sort(function(a,b){
          var x=a[key];
          var y=b[key];
          return ((x<y)?-1:((x>y)?1:0));
      });
  }
}


// 注册插件全局通用
export default {
  install() {
    Vue.prototype.$global = global;
  },
  global
}



// WEBPACK FOOTER //
// ./src/core/global/global.js